import { makeTranslationHelpers } from '@/hooks/useTranslation';

const { useTranslation } = makeTranslationHelpers('web');

/**
 * Translations for the Plans shared components specifically.
 */
const useComponentTranslation = <K extends Parameters<typeof t>[0]>() => {
  const t = useTranslation();
  /**
   * Hide the global component key so that we can eventually split shared component translations
   * into their own namespaces if needed. This also ensures that the shared component only uses
   * its own translations.
   */
  return (
    key: K extends `app.component.companyIntrinsicDiscount.${infer SubKey}`
      ? SubKey
      : never,
    options?: Parameters<typeof t>[1]
  ) => t(`app.component.companyIntrinsicDiscount.${key}`, options);
};

export { useComponentTranslation };
